module.exports = __webpack_public_path__ + "img/music-promotion-creative-images.e5677e7b.jpg";